import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmStaffComponent } from './confirm-staff.component';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '../../../shared/material.module';
import { StateManagementButtonsModule } from '../../../shared/componets/state-management-buttons/state-management-buttons.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NgxMaskModule } from 'ngx-mask';
import { ScheduleCreationStateButtonsModule } from '../shared/schedule-creation-state-buttons/schedule-creation-state-buttons.module';
import { ManualAddModule } from '../add-staff/components/manual-add/manual-add.module';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    ConfirmStaffComponent
  ],
  exports: [ConfirmStaffComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StateManagementButtonsModule,
    MatTableModule,
    NgxMaskModule,
    MatSortModule,
    ScheduleCreationStateButtonsModule,
    ManualAddModule,
    MatDialogModule
  ]
})
export class ConfirmStaffModule { }
